import { render, staticRenderFns } from "./PurchasedItem.vue?vue&type=template&id=f75caccc&scoped=true&"
import script from "./PurchasedItem.vue?vue&type=script&lang=js&"
export * from "./PurchasedItem.vue?vue&type=script&lang=js&"
import style0 from "./PurchasedItem.vue?vue&type=style&index=0&id=f75caccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75caccc",
  null
  
)

export default component.exports